import {createSlice} from '@reduxjs/toolkit';
const R = require('ramda');

const initialState = {
    order: {},
};

const orderSlice = createSlice({
    name: 'order',
    initialState,
    reducers: {
        setOrder: (state, action) => {
            state.order = action.payload;
        },
    },
});

export const {actions} = orderSlice;
export const {
    setOrder,
} = actions;

// reducers

// selectors
export const selOrder = (state) => state.order.order;


const orderReducer = {
    order: orderSlice.reducer,
};
export default orderReducer;
